import { Component } from 'preact'
import WidgetV2Preview from '../components/widget-v2-preview';
import { LinkFilter, ThemeFilter } from '../components/filters';
import { __ } from '../../locales'

class V2AverageRating extends Component {
  render(props, state) {
    return (
      <WidgetV2Preview
        {...props}
        title={__('widget.trust_score_badge.name')}
        description={__('widget.trust_score_badge.description')}
        bestFor={[__('global.homepage'), __('global.footer')]}
        widgetName={'average-rating-widget'}
        extraParams={[
          'slugs',
        ]}
        badgeTitle={__('widget.type.badge')}
        badgeColor={'#00897D'}
        badgeFontColor={'#FFFFFF'}
        fixedWidth={'140px'}
        fixedHeight={'95px'}
        defaultHeight={'400px'}
      >
        <div class={'filters-wrapper mt-5 mb-5'}>
          <ThemeFilter {...props} />
          <LinkFilter
              {...props}
              hidden={props.inputs?.profileType === 'specialist' && props.selectedProfiles?.length <= 1}
          />
        </div>
      </WidgetV2Preview>
    );
  }
}

export default V2AverageRating
